import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';
import KeyboardNavigatable from 'flarum/common/utils/KeyboardNavigatable';
export default function addSlashCommandsAutocomplete() {
  extend(TextEditor.prototype, 'oninit', function () {
    this.slashAutocompleteIdx = 0;
    this.slashMatches = [];
  });
  extend(TextEditor.prototype, 'view', function (vdom) {
    if (!this.slashMatches || this.slashMatches.length === 0) return;

    // Asegurarnos de que vdom tiene hijos
    if (!vdom || !vdom.children) return;
    vdom.children.push(m("div", {
      className: "Aurrerapedia-SlashAutocomplete dropdown-menu dropdown-menu--active"
    }, m("ul", {
      className: "Dropdown-menu"
    }, this.slashMatches.map((match, index) => m("li", {
      className: this.slashAutocompleteIdx === index ? 'active' : '',
      onclick: () => this.applySlashCommand(match),
      onmouseenter: () => this.slashAutocompleteIdx = index
    }, m("button", {
      type: "button"
    }, m("span", {
      className: "SlashCommand-label"
    }, "&", match.command), m("span", {
      className: "SlashCommand-description"
    }, " - ", match.description)))))));
  });
  TextEditor.prototype.applySlashCommand = function (match) {
    const value = this.attrs.value;
    const selection = this.attrs.selectionRange;
    const lastAmpersandIndex = value.lastIndexOf('&', selection.start - 1);
    if (lastAmpersandIndex !== -1) {
      const newValue = value.substring(0, lastAmpersandIndex) + '&' + match.command + ' ' + value.substring(selection.start);
      this.attrs.onchange(newValue);
      this.slashMatches = [];
      this.slashAutocompleteIdx = 0;
      this.$('textarea').focus();
    }
  };
  extend(TextEditor.prototype, 'oninput', function () {
    const value = this.attrs.value || '';

    // Intentar obtener la posición del cursor de ProseMirror si está disponible
    let selection = this.attrs.selectionRange;
    if (!selection && this.editor && typeof this.editor.getSelectionRange === 'function') {
      selection = this.editor.getSelectionRange();
    }

    // Fallback final para textarea clásica
    if (!selection) {
      selection = {
        start: this.$('textarea') && this.$('textarea').length ? this.$('textarea')[0].selectionStart : 0,
        end: this.$('textarea') && this.$('textarea').length ? this.$('textarea')[0].selectionEnd : 0
      };
    }
    if (!selection || typeof selection.start === 'undefined') {
      this.slashMatches = [];
      return;
    }

    // Buscamos el último ampersand antes de la posición del cursor
    const lastAmpersandIndex = value.lastIndexOf('&', selection.start - 1);
    if (lastAmpersandIndex !== -1) {
      // Verificamos si el ampersand está al inicio, tras espacio o tras nueva línea
      const charBefore = lastAmpersandIndex > 0 ? value[lastAmpersandIndex - 1] : null;
      if (charBefore === null || charBefore === ' ' || charBefore === '\n') {
        const typed = value.substring(lastAmpersandIndex + 1, selection.start).toLowerCase();

        // No autocompletar si hay espacios después del ampersand o es demasiado largo
        if (typed.includes(' ') || typed.length > 20) {
          this.slashMatches = [];
          return;
        }
        const commands = [{
          command: 'clasificacion',
          description: 'Tabla de liga'
        }, {
          command: 'proximo',
          description: 'Siguiente partido'
        }, {
          command: 'ultimo',
          description: 'Último partido jugado'
        }, {
          command: 'tabla',
          description: 'Alias de clasificación'
        }];
        this.slashMatches = commands.filter(c => c.command.startsWith(typed));
        this.slashAutocompleteIdx = 0;
      } else {
        this.slashMatches = [];
      }
    } else {
      this.slashMatches = [];
    }
  });

  // Manejar navegación por teclado (flechas y enter)
  extend(TextEditor.prototype, 'onkeydown', function (e) {
    if (!this.slashMatches || this.slashMatches.length === 0) return;
    if (e.key === 'ArrowDown') {
      this.slashAutocompleteIdx = (this.slashAutocompleteIdx + 1) % this.slashMatches.length;
      e.preventDefault();
      m.redraw();
    } else if (e.key === 'ArrowUp') {
      this.slashAutocompleteIdx = (this.slashAutocompleteIdx - 1 + this.slashMatches.length) % this.slashMatches.length;
      e.preventDefault();
      m.redraw();
    } else if (e.key === 'Enter' || e.key === 'Tab') {
      this.applySlashCommand(this.slashMatches[this.slashAutocompleteIdx]);
      e.preventDefault();
      m.redraw();
    } else if (e.key === 'Escape') {
      this.slashMatches = [];
      m.redraw();
    }
  });
}